// 供应商
import api from "../api/api";
import {
  SET_SUPPLIERINFO,
  SET_AVATAR,
  SET_CUSTOMER,
  SET_BASKET,
  DELETE_BASKET,
  CLEAR_BASKET
} from "./mutation-types";

const supplierInfo = JSON.parse(localStorage.getItem("supplierInfo")) || {};
const basket = JSON.parse(localStorage.getItem("basket")) || {
  products: [],
  suppliers: []
};
const { isLogging } = JSON.parse(localStorage.getItem("auth")) ? true : false;

export default {
  state: {
    supplierInfo: supplierInfo,
    headPhoto: "",
    messageCount: null,
    isLogging: isLogging,
    basket: basket
  },
  mutations: {
    [SET_CUSTOMER](state, data) {
      state.headPhoto = data;
    },
    messageCount(state, data) {
      state.messageCount = data;
    },
    [SET_SUPPLIERINFO](state, data) {
      state.supplierInfo = data;
    },
    [SET_AVATAR](state, data) {
      state.headPhoto = data;
    },
    [SET_BASKET](state, data) {
      if (data.type == 1) {
        var products = state.basket.products;
        var items = state.basket.products.find(p => p.PId == data.product.PId);
        if (items) {
        } else {
          products.push(data.product);
        }
        state.basket.products = products;
      } else {
        var suppliers = state.basket.suppliers;
        var items = state.basket.suppliers.find(
          p => p.ShopId == data.supplier.ShopId
        );
        if (items) {
        } else {
          suppliers.push(data.supplier);
        }
        state.basket.suppliers = suppliers;
      }
      localStorage.setItem("basket", JSON.stringify(state.basket));
    },
    [DELETE_BASKET](state, data) {
      if (data.type == 1) {
        var items1 = state.basket.products;
        for (var i in items1) {
          if (items1[i].PId == data.id) {
            items1.splice(i, 1);
          }
        }
        state.basket.products = items1;
      } else {
        var items2 = state.basket.suppliers;
        for (var i in items2) {
          if (items2[i].ShopId == data.id) {
            items2.splice(i, 1);
          }
        }
        state.basket.suppliers = items2;
      }
      localStorage.setItem("basket", JSON.stringify(state.basket));
    },
    [CLEAR_BASKET](state, data) {
      if (data.type == 1) {
        state.basket.products = [];
      } else {
        state.basket.suppliers = [];
      }
      localStorage.setItem("basket", JSON.stringify(state.basket));
    },
    getBasketProducts(state, data) {
      state.basket = data;
    }
  },
  actions: {
    getBasket({ commit }) {
      return new Promise(resolve => {
        commit("getBasketProducts", basket);
        resolve(basket);
      });
    },
    getSupplier({ commit }) {
      return new Promise((resolve, reject) => {
        api.customer
          .loadCustomerInfo({})
          .then(res => {
            commit(SET_SUPPLIERINFO, res.data);
            localStorage.setItem("supplierInfo", JSON.stringify(res.data));
            commit(SET_AVATAR, res.data.HeadPhoto);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getMessageCount({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (this.getters.isLogging) {
          dispatch("getSupplier").then(() => {
            let param = {
              UserId: JSON.parse(localStorage.getItem("supplierInfo")).UserId,
              ReceipType: JSON.parse(localStorage.getItem("cUserInfo"))
                ? "C"
                : "SU"
            };
            api.system
              .getPlatformMessageCount(param)
              .then(response => {
                commit("messageCount", response.data || null);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      });
    }
  }
};
